import parseEanFile from './parseEanFile'

export { parseEanFile }
